import axios from "axios";
import { Message } from "element-ui";
import router from "../router";
axios.defaults.baseURL = process.env.BASE_API;
axios.defaults.timeout = 100000;
let Axios = axios.create();
Axios.interceptors.response.use(
  res => {
    if (res.status === 200) {
      if (
        res.data.code == 401 ||
        res.data.code == 402 ||
        res.data.code == 403
      ) {
        //提示登录失效，看用户选择是否返回登录页
        window.localStorage.removeItem("token");
        router.push("/login");
        Message({
          message: "登录已过期，请重新登录",
          type: "error"
        });
        return Promise.reject(error);
      }
      if (!res.data.code || res.data.code == 200 || res.data.code === 0) {
        return res;
      } else {
        Message({
          message: res.data.msg,
          type: "error"
        });
        return Promise.reject(res.data.msg);
      }
    }
  },
  error => {
    return Promise.reject(error);
  }
);

Axios.interceptors.request.use(
  config => {
    if (window.localStorage.getItem("token")) {
      config.headers["Authorization"] = window.localStorage.getItem("token");
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export { Axios };



// WEBPACK FOOTER //
// ./src/utils/axios.js